export const httpHeaders = {
  AUTHORIZATION: "Authorization",
  CONTENT_TYPE: "Content-Type",
  contentTypes: {
    APPLICATION_JSON: "application/json",
    APPLICATION_JSON_PATCH: "application/json-patch+json",
    MULTIPART_FORM_DATA: "multipart/form-data"
  },
  ACCEPT: "Accept",
  acceptTypes: {
    ALL: "*/*",
    APPLICATION_JSON: "application/json",
    APPLICATION_JSON_HAL: "application/hal+json"
  }
};
